import { useTranslation } from 'react-i18next'
import React from 'react'

import { useInputState } from '@/hooks/inputStateContext'
import { useMerchant } from '@/hooks/merchantContext'
import CollapsibleList from '@/components/CollapsibleList'
import SettingControl from '../SettingControl'

/**
 *
 * @param {*} props
 * @returns
 */
export default function InvoiceSettings (props) {
  const [expand, setExpand] = React.useState(false)
  const [inputState] = useInputState()
  const [merchantState] = useMerchant()
  const { t } = useTranslation()

  const region = merchantState.merchant?.region?.toUpperCase()
  const isTH = region === 'TH'

  const label = (twKey, thKey) => isTH ? t(thKey) : t(twKey)

  const SETTINGS = [
    {
      label: label('invoice.settings.enableInvoice', 'invoice.settings.enableInvoiceTH'),
      paramaterName: 'enableInvoice',
      regions: ['TW', 'TH'],
      type: 'switch',
    },
    {
      // TH: eInvoiceCompanyName 即為 Owner Name（共用同一 key）
      label: label('invoice.settings.companyName', 'invoice.settings.ownerName'),
      paramaterName: 'eInvoiceCompanyName',
      regions: ['TW', 'TH'],
      type: 'input',
      inputOption: { type: 'text' },
      // TH Owner Name 上限 80（PMO 指示，DMP-46）；TW 維持 60
      inputProps: { required: true, maxLength: isTH ? 80 : 60 },
    },
    {
      label: label('invoice.settings.taxID', 'invoice.settings.taxIDTH'),
      paramaterName: 'taxId',
      regions: ['TW', 'TH'],
      type: 'input',
      inputOption: { type: 'text' },
      inputProps: { required: true, maxLength: isTH ? 13 : 8 },
    },
    {
      label: t('invoice.settings.password'),
      paramaterName: 'eInvoicePassword',
      regions: ['TW'],
      type: 'input',
      inputOption: { type: 'text' },
      inputProps: { required: true },
    },
    {
      label: t('invoice.settings.companyAddress'),
      paramaterName: 'eInvoiceCompanyAddress',
      regions: ['TW'],
      type: 'input',
      inputOption: { type: 'text' },
      inputProps: { required: true, maxLength: 100 },
    },
    {
      label: t('invoice.settings.companyPhone'),
      paramaterName: 'eInvoiceCompanyPhone',
      regions: ['TW'],
      type: 'input',
      inputOption: { type: 'text' },
      inputProps: { maxLength: 26 },
    },
    {
      label: t('invoice.settings.qrCodeSeed'),
      paramaterName: 'eInvoiceQRCodeSeed',
      regions: ['TW'],
      type: 'input',
      inputOption: { type: 'text' },
      inputProps: { required: true },
    },
    {
      label: t('invoice.settings.posId'),
      paramaterName: 'posId',
      regions: ['TH'],
      type: 'input',
      inputOption: { type: 'text' },
      inputProps: { maxLength: 60 },
    },
    {
      label: t('invoice.settings.headquarter'),
      paramaterName: 'isHeadquarter',
      regions: ['TH'],
      type: 'radioWithInput',
      pairWith: 'branchNo',
      options: [
        { value: true, label: t('invoice.settings.headquarter') },
        { value: false, label: t('invoice.settings.branchNo'), showInput: true },
      ],
      inputLabel: t('invoice.settings.enterBranchNo'),
      inputProps: { maxLength: 60 },
    },
  ]

  const visibleSettings = SETTINGS.filter((setting) => setting.regions.includes(region))

  return (
    <CollapsibleList
      title={isTH ? t('invoice.settings.titleTH') : t('invoice.settings.title')}
      expand={expand}
      setExpand={setExpand}
    >
      {visibleSettings.map((setting) => {
        // enableInvoice 以外的欄位僅在啟用發票後顯示
        if (setting.paramaterName !== 'enableInvoice' && !inputState.enableInvoice) {
          return null
        }
        return <SettingControl key={setting.paramaterName} setting={setting} />
      })}
    </CollapsibleList>
  )
}
